module.exports = __webpack_public_path__ + "img/create.e5f08237.svg";